<template>
  <div id="wizard">
    <!-- <div>{{ now | moment("jD jMMMM,jYYYY HH:mm") }}</div>
    <button type="button" @click="createTestCalender(17)">fgfg</button> -->
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="قبلی"
      next-button-text="بعدی"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
      ref="formWizard"
    >
      <!-- account detail tab -->
      <tab-content
        :before-change="beforeTab1Switch"
        title="اطلاعات اولیه"
        icon="feather icon-info"
        :lazy="true"
      >
        <b-row key="879">
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">اطلاعات اولیه</h5>
            <small class="text-muted"> اطلاعات اولیه تور را وارد کنید. </small>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="name1" class="text-capitalize"
                >عنوان:<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                key="name1"
                v-model="tourInput.name"
                id="name"
                placeholder="عنوان تور را وارد نمایید"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="slug" class="text-capitalize"
                >slug|اسلاگ:<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                v-model="tourInput.slug"
                id="slug"
                key="slug1"
                placeholder="same1"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="host" class="text-capitalize">
                میزبان :<span class="text-danger">*</span></label
              >
              <v-select
                id="host"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.host_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="owners"
                label="full_name"
                :reduce="(owner) => owner.id"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
              <label for="province_status" class="text-capitalize">
                وضعیت :<span class="text-danger">*</span>
              </label>
              <b-form-checkbox
                v-model="tourInput.status"
                :aria-describedby="ariaDescribedby"
                value="active"
                >فعال</b-form-checkbox
              >
              <!-- @input="removeErrors('status')" -->
              <b-form-checkbox
                v-model="tourInput.status"
                :aria-describedby="ariaDescribedby"
                value="inactive"
                >پیش نویس</b-form-checkbox
              >
              <!-- @input="removeErrors('status')"
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage> -->
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
              <label for="province_close_booking" class="text-capitalize">
                بستن تقویم رزرو :<span class="text-danger">*</span>
              </label>
              <b-form-checkbox
                  v-model="tourInput.close_booking"
                  :aria-describedby="ariaDescribedby"
                  value="active"
              >فعال</b-form-checkbox
              >
              <!-- @input="removeErrors('close_booking')" -->
              <b-form-checkbox
                  v-model="tourInput.close_booking"
                  :aria-describedby="ariaDescribedby"
                  value="inactive"
              >پیش نویس</b-form-checkbox
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
              <label for="show_index_page" class="text-capitalize">
                وضعیت نمایش :<span class="text-danger">*</span>
              </label>
<!--              {{tourInput}}-->
              <b-form-checkbox
                v-model="tourInput.show_index_page"
                :aria-describedby="ariaDescribedby"
                :value="1"
                >نمایش در صفحه اصلی</b-form-checkbox
              >
              <!-- @input="removeErrors('status')" -->
              <b-form-checkbox
                v-model="tourInput.show_index_page"
                :aria-describedby="ariaDescribedby"
                :value="0"
                >عدم نمایش در صفحه اصلی</b-form-checkbox
              >
              <!-- @input="removeErrors('status')"
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage> -->
            </b-form-group>
          </b-col>



          <b-col md="3">
            <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
              <label for="show_date_page" class="text-capitalize">
                وضعیت نمایش تاریخ در ص جزئیات :<span class="text-danger">*</span>
              </label>

              <b-form-checkbox
                  v-model="tourInput.show_date_page"
                  :aria-describedby="ariaDescribedby"
                  value="1"
              >نمایش در صفحه جزئیات</b-form-checkbox
              >
              <!-- @input="removeErrors('status')" -->
              <b-form-checkbox
                  v-model="tourInput.show_date_page"
                  :aria-describedby="ariaDescribedby"
                  value="0"
              >عدم نمایش در صفحه جزئیات</b-form-checkbox
              >
              <!-- @input="removeErrors('status')"
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage> -->
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-2">
            <b-form-group>
              <label for="score" class="text-capitalize">
                امتیاز  ( مثلا 4.1) حداکثر امتیاز 5 می باشد. :
              </label>
              <b-form-input
                  lazy
                  v-model="tourInput.score"
                  id="score"
                  type="number"
                  placeholder="مثال: 4.1"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label for="host" class="text-capitalize">
                دسته بندی :<span class="text-danger">*</span>
              </label>
              <v-select
                id="host"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.category_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categories"
                label="name"
                :reduce="(category) => category.id"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="residence_area" class="text-capitalize">
                سبک تور:<span class="text-danger">*</span>
              </label>
              <v-select
                id="residence_area"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.tour_style"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tour_style"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="residence_area" class="text-capitalize">
                نوع حمل و نقل تور:<span class="text-danger">*</span>
              </label>
              <v-select
                id="residence_area"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.tour_transportation"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tour_transportation"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label for="residence_area" class="text-capitalize">
                توضیحات در مورد حمل و نقل (  اختیاری ):<span class="text-danger">*</span>
              </label>
              <b-form-textarea
                  lazy
                  v-model="tourInput.transfer_description"
                  rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>


          <b-col md="6">
            <b-form-group>
              <label for="host" class="text-capitalize">
                گروه سنی تور:<span class="text-danger">*</span>
              </label>
              <v-select
                id="host"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.age_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="ages"
                label="name"
                :reduce="(age) => age.id"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="residence_area" class="text-capitalize">
                درجه سختی تور:<span class="text-danger">*</span>
              </label>
              <v-select
                style="direction: rtl"
                id="residence_area"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="tourInput.tour_difficulty"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tour_difficulty"
              />
            </b-form-group>
          </b-col>

          <b-col key="key-min_day_before_reservation" md="3">
            <b-form-group>
              <label for="min_day_before_reservation" class="text-capitalize"
                >حداقل روز قبل از رزرو<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                v-model="tourInput.min_day_before_reservation"
                id="min_day_before_reservation"
                key="min_day_before_reservation"
                placeholder="min_day_before_reservation"
              />
            </b-form-group>
          </b-col>

          <b-col key="key-min_people" md="3">
            <b-form-group>
              <label for="min_people" class="text-capitalize"
                >حداقل افراد تور :<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                v-model="tourInput.min_people"
                id="min_people"
                key="min_people"
                placeholder="min_people"
              />
            </b-form-group>
          </b-col>
          <b-col key="key-max_people" md="3">
            <b-form-group>
              <label for="max_people" class="text-capitalize"
                >حداکثر افراد تور :<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                v-model="tourInput.max_people"
                id="max_people"
                key="max_people"
                placeholder="12"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group>
              <label for="price" class="text-capitalize"
              >قیمت عمومی یا میانگین قیمت صرفا برای  نمایش را وارد نمایید (هزینه تیکت یا میانگین هزینه های تیکت) </label
              >
              <b-form-input
                  lazy
                  key="price"
                  v-model="tourInput.price"
                  id="price"
                  placeholder="میانگین قیمت را وارد نمایید"
              />
<!--              <div >{{ formatnumber(experienceInput.price)}} تومان   </div>-->
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-form-group>
              <label for="description" class="text-capitalize"
                >توضیحات:<span class="text-danger">*</span></label
              >
              <quill-editor
                  style=" direction: rtl !important;text-align: right !important;height: 400px;font-family: anjoman !important;"
                  class="editor-font"
                  v-model="tourInput.description"
              />
<!--              <vue-editor
                v-model="tourInput.description"
                :editorToolbar="customToolbar"
              ></vue-editor>-->
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-4" >
            <b-form-group>
              <label for="visa_description" class="text-capitalize"
                >توضیحات در مورد ویزا:<span class="text-danger">*</span></label
              >
              <quill-editor
                  style=" direction: rtl !important;text-align: right !important;height: 400px;font-family: anjoman !important;"
                  class="editor-font"
                  v-model="tourInput.visa_description"
              />
<!--              <vue-editor
                v-model="tourInput.visa_description"
                :editorToolbar="customToolbar"
              ></vue-editor>-->
            </b-form-group>
          </b-col>

          <b-col md="12"  style="margin-top: 75px">
            <b-form-group>
              <label for="slug" class="text-capitalize"
                >آدرس وبلاگ جهت کسب اطلاعات بیشتر :<span class="text-danger"
                  >*</span
                ></label
              >
              <b-form-input
                lazy
                v-model="tourInput.blog_url"
                id="blog_url"
                placeholder="آدرس وبلاگ "
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label for="covid" class="text-capitalize"
                >توضیحات درباره کرونا:</label
              >
              <b-form-textarea
                lazy
                v-model="tourInput.covid"
                rows="2"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="name1" class="text-capitalize"
                >کمیسیون به ازای هر فرد بر اساس تومان :<span class="text-danger"
                  >*</span
                ></label
              >
              <b-form-input
                lazy
                key="name1"
                v-model="tourInput.commission_per_person"
                id="name"
                placeholder="کمیسیون به ازای هر فرد"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="name1" class="text-capitalize"
                >کمیسیون به ازای هر ترانسفر :<span class="text-danger"
                  >*</span
                ></label
              >
              <b-form-input
                lazy
                key="name1"
                v-model="tourInput.commission_per_group"
                id="name"
                placeholder="کمیسیون به ازای هر ترانسفر"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label for="name1" class="text-capitalize"
                >نحوه ترتیب نمایش در سایت (اعداد کمتر اولویت بالاتر) :<span
                  class="text-danger"
                  >*</span
                ></label
              >
              <b-form-input
                lazy
                key="name1"
                v-model="tourInput.show_order_number"
                id="name"
                placeholder="نحوه ترتیب نمایش در سایت"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal details -->
      <tab-content
        :before-change="beforeTab2Switch"
        title="موقعیت"
        icon="feather icon-user"
        :lazy="true"
      >
        <b-row>
          <!-- start destination -->
          <b-col md="6">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">مقصد تور</h5>
                <small class="text-muted">آدرس و موقعیت روی نقشه</small>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label for="residence_area" class="text-capitalize">
                    نوع موقعیت تور داخلی / خارجی:<span class="text-danger"
                      >*</span
                    >
                  </label>
                  <v-select
                    id="residence_area"
                    :components="{ OpenIndicator }"
                    class="bg-white"
                    :clearable="false"
                    v-model="tourInput.tour_destination_position"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="tour_type"
                    style="z-index: 11300"
                  />
                </b-form-group>
              </b-col>
              <template v-if="tourInput.tour_destination_position == 'داخلی'">
                <b-col md="12">
                  <b-form-group style="z-index: 11200">
                    <label for="city_province" class="text-capitalize">
                      استان :</label
                    >
                    <v-select
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.state_destination_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(province) => province.id"
                      :options="provinces"
                      placeholder="برای جستجو تایپ کنید"
                      @input="
                        getSelectedProvincesCity($event, 'destinationMode')
                      "
                      style="z-index: 11200"
                    />
                    <!-- <ErrorMessage
              errorType="state"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group style="z-index: 11000">
                    <label for="city_province" class="text-capitalize">
                      شهر :</label
                    >
                    <v-select
                      :loading="showGettingCityLoadingDestination"
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.city_destination_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(city) => city.id"
                      :options="citiesDestination"
                      placeholder="برای جستجو تایپ کنید"
                      style="z-index: 11000"
                    />
                    <!-- <ErrorMessage
              errorType="city"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
              </template>
              <template v-if="tourInput.tour_destination_position == 'خارجی'">
                <b-col md="12">
                  <b-form-group class="">
                    <label for="capital_country" class="text-capitalize">
                      کشور :</label
                    >
                    <v-select
                      id="capital_country"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.country_destination_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(country) => country.id"
                      :options="countries"
                      placeholder="برای جستجو تایپ کنید"
                      @input="getSelectedCountriesCity($event,'destinationMode')"
                      style="z-index: 11100"
                    />
                    <!-- <ErrorMessage
              errorType="state"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group class="">
                    <label for="city_province" class="text-capitalize">
                      شهر کشور :</label
                    >
                    <v-select
                      :loading="showGettingCapitalLoading"
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.capital_destination_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(city) => city.id"
                      :options="destinationCapitals"
                     
                      placeholder="برای جستجو تایپ کنید"
                      style="z-index: 11000"
                    />
                     <!-- @input="getSelectedCapitalLocaion" -->
                    <!-- <ErrorMessage
              errorType="city"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
              </template>
              <b-col md="12">
                <b-form-group
                  label="آدرس مقصد تور "
                  label-for="address_destination"
                >
                  <b-form-textarea
                    lazy
                    id="address_destination"
                    placeholder="کوچه یکم، پلاک دو"
                    rows="5"
                    v-model="tourInput.address_destination"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" class="mt-5">
                <b-overlay
                  :show="showDestinationMap"
                  rounded="sm"
                  :opacity="0.5"
                  :blur="`50px`"
                  :z-index="10000"
                  v-click-outside="onClickOutsideDestinationMap"
                >
                  <div id="vvv" style="position: relative">
                    <l-map
                      :zoom="zoomDestination"
                      :center="centerDestination"
                      :options="mapOptions"
                      style="height: 400px"
                      @update:center="centerUpdateDestination"
                      @update:zoom="zoomUpdateDestination"
                      ref="mymapDestination"
                      @ready="doSomethingOnReady()"
                    >
                      <l-tile-layer :url="url" :attribution="attribution" />
                    </l-map>

                    <feather-icon
                      icon="MapPinIcon"
                      size="20"
                      fill="#FFF "
                      style="
                        position: absolute;
                        top: 50%;
                        margin-top: -20px;
                        z-index: 999;
                        left: 50%;
                        margin-left: -10px;
                      "
                    />
                  </div>
                  <template #overlay>
                    <div class="text-center">
                      <b-button
                        ref="cancel"
                        variant="primary"
                        style="opacity: 0.8"
                        size="2xl"
                        aria-describedby="cancel-label"
                        @click="
                          (showDestinationMap = false),
                            $refs.mymapDestination.mapObject._onResize()
                        "
                      >
                        انتخاب لوکیشن روی نقشه
                      </b-button>
                    </div>
                  </template>
                </b-overlay>
              </b-col>
            </b-row>
          </b-col>
          <!-- end destination -->

          <!-- start origin  -->
          <b-col md="6">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">مبدا تور</h5>
                <small class="text-muted">آدرس و موقعیت روی نقشه</small>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label for="residence_area" class="text-capitalize">
                    نوع موقعیت تور داخلی / خارجی:<span class="text-danger"
                      >*</span
                    >
                  </label>
                  <v-select
                    id="residence_area"
                    :components="{ OpenIndicator }"
                    class="bg-white"
                    :clearable="false"
                    v-model="tourInput.tour_origin_position"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="tour_type"
                    style="z-index: 11300"
                  />
                </b-form-group>
              </b-col>
              <template v-if="tourInput.tour_origin_position == 'داخلی'">
                <b-col md="12">
                  <b-form-group style="z-index: 11200">
                    <label for="city_province" class="text-capitalize">
                      استان :</label
                    >
                    <v-select
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.state_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(province) => province.id"
                      :options="provinces"
                      placeholder="برای جستجو تایپ کنید"
                      @input="getSelectedProvincesCity($event, 'originMode')"
                      style="z-index: 11200"
                    />
                    <!-- <ErrorMessage
              errorType="state"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group style="z-index: 11000">
                    <label for="city_province" class="text-capitalize">
                      شهر :</label
                    >

                    <v-select
                      :loading="showGettingCityLoadingOrigin"
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.city_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(city) => city.id"
                      :options="citiesOrigin"
                      @input="getSelectedCityLocaion"
                      placeholder="برای جستجو تایپ کنید"
                      style="z-index: 11000"
                    />
                    <!-- <ErrorMessage
              errorType="city"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
              </template>

              <template v-if="tourInput.tour_origin_position == 'خارجی'">
                <b-col md="12">
                  <b-form-group class="">
                    <label for="capital_country" class="text-capitalize">
                      کشور :</label
                    >
                    <v-select
                      id="capital_country"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.country_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(country) => country.id"
                      :options="countries"
                      placeholder="برای جستجو تایپ کنید"
                      @input="getSelectedCountriesCity($event,'originMode')"
                    />
                    <!-- <ErrorMessage
              errorType="state"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group class="">
                    <label for="city_province" class="text-capitalize">
                      شهر کشور :</label
                    >
                    <v-select
                      :loading="showGettingCapitalLoading"
                      id="city_province"
                      :components="{ OpenIndicator }"
                      class="bg-white"
                      :clearable="false"
                      v-model="tourInput.capital_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :reduce="(city) => city.id"
                      :options="capitals"
                     
                      placeholder="برای جستجو تایپ کنید"
                    />
                     <!-- @input="getSelectedCapitalLocaion" -->
                    <!-- <ErrorMessage
              errorType="city"
              :errorMessages="errorMessage"
            ></ErrorMessage> -->
                  </b-form-group>
                </b-col>
              </template>
              <b-col md="12">
                <b-form-group label="آدرس مبدا و شروع تور " label-for="address">
                  <b-form-textarea
                    lazy
                    id="address"
                    placeholder="کوچه یکم، پلاک دو"
                    rows="5"
                    v-model="tourInput.address_origin"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" class="mt-5">
                <b-overlay
                  :show="showOriginMap"
                  rounded="sm"
                  v-click-outside="onClickOutsideOrigignMap"
                  :opacity="0.5"
                  :blur="`50px`"
                  :z-index="10000"
                >
                  <div id="vvv" style="position: relative">
                    <l-map
                      :zoom="zoom"
                      :center="center"
                      :options="mapOptions"
                      style="height: 400px"
                      @update:center="centerUpdate"
                      @update:zoom="zoomUpdate"
                      ref="mymap"
                      @ready="doSomethingOnReady()"
                    >
                      <l-tile-layer :url="url" :attribution="attribution" />
                    </l-map>

                    <feather-icon
                      icon="MapPinIcon"
                      size="20"
                      fill="#FFF "
                      style="
                        position: absolute;
                        top: 50%;
                        margin-top: -20px;
                        z-index: 9999;
                        left: 50%;
                        margin-left: -10px;
                      "
                    />
                  </div>
                  <template #overlay>
                    <div class="text-center">
                      <b-button
                        ref="cancel"
                        variant="primary"
                        style="opacity: 0.8"
                        size="2xl"
                        aria-describedby="cancel-label"
                        @click="
                          (showOriginMap = false),
                            $refs.mymap.mapObject._onResize()
                        "
                      >
                        انتخاب لوکیشن روی نقشه
                      </b-button>
                    </div>
                  </template>
                </b-overlay>
              </b-col>
            </b-row>
          </b-col>
          <!-- end origin -->
        </b-row>
      </tab-content>
      <!-- personal details -->
      <tab-content
        :before-change="beforeTab3Switch"
        title="قوانین و مقررات"
        icon="feather icon-user"
        :lazy="true"
      >
        <b-row>
          <b-col cols="12" class="mb-1">
            <h5 class="mb-0">قوانین لغو رزرو</h5>
            <div v-if="tourInput.rules.length > 0">
              سیاست این تور گردشگری

              <span style="color: red">    {{
                  tourInput.rules[0].tour_rule
                      ? tourInput.rules[0].tour_rule.name
                      : tourInput.rules[0].name
                }}</span>
              انتخاب شده است .
            </div>
            <small class="text-muted"
              >از بین گزینه های زیر یک مورد را انتخاب کنید
            </small>
<!--            <div v-if="editMode">قانون انتخاب شده :

              <span

                  v-for="(rule, index) in rules"
                  :key="'rule_' + index"
                  style="color: red"
              >
                {{ rule.name }}
              </span>
              است.
            </div>-->
          </b-col>
          <b-col md="6" class="mb-2">
            <!-- <div v-if="tourInput.rules.length > 0">
              سیاست این ترانسفر

              {{
                tourInput.rules[0].car_rule
                  ? tourInput.rules[0].car_rule.name
                  : tourInput.rules[0].name
              }}
              می باشد.
            </div> -->
            <b-form-group v-slot="{ ariaDescribedby }" class="" v-if="editMode">
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                v-model="selectedRule"
                v-for="(rule, index) in rules"
                :key="'rule_' + index"
                :value="rule"
              >
                {{ rule.name }}
                <small class="text-muted">{{ rule.description }}</small>
              </b-form-radio>

              <!-- &lt;!&ndash;
              <ErrorMessage
                errorType="state"
                :errorMessages="errorMessage"
              ></ErrorMessage> -->
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }" class="" v-else>
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                v-model="tourInput.rules[0]"
                v-for="(rule, index) in rules"
                :key="'rule2_' + index"
                :value="rule"
              >
                {{ rule.name }}
                <small class="text-muted">{{ rule.description }}</small>
              </b-form-radio>

              <!-- <ErrorMessage
                errorType="state"
                :errorMessages="errorMessage"
              ></ErrorMessage> -->
            </b-form-group>
          </b-col>

          <b-col cols="12" class="mb-1">
            <h5 class="mb-0">مقررات تور</h5>
            <small class="text-muted">مقررات تور را انتخاب کنید </small>
          </b-col>
          <b-col
            md="3"
            v-for="(compo, index0) in regulationsItemArray"
            :key="'regulationsItemArray_' + index0"
          >
            <div>
              <b-form-checkbox v-model="compo.disable" :label="compo.name">
                {{
                  compo.car_regulation ? compo.car_regulation.name : compo.name
                }}
              </b-form-checkbox>
            </div>
            <div>
              <b-form-input
                lazy
                :disabled="!compo.disable"
                type="text"
                v-model="compo.ownerDescription"
                size="sm"
              />
            </div>
          </b-col>
        </b-row>
      </tab-content>
      <!-- address -->
      <tab-content
        title="اطلاعات تکمیلی"
        icon="feather icon-map-pin"
        :lazy="true"
      >
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">اطلاعات تکمیلی</h5>
            <small class="text-muted">سوالات متداول</small>
          </b-col>
        </b-row>
        <b-row
          v-for="(question, index) in tourInput.faqs"
          :key="'faqs_' + index"
        >
          <b-col key="key-question-name" md="3">
            <b-form-group>
              <label for="question_name" class="text-capitalize"
                >عنوان سوال:<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                key="question_name"
                v-model="question.question"
                id="question_name"
                placeholder="سیگار میتونم بیارم ؟"
              />
            </b-form-group>
          </b-col>
          <b-col key="key_answer_question" md="3">
            <b-form-group>
              <label for="key_answer_question1" class="text-capitalize"
                >پاسخ سوال:<span class="text-danger">*</span></label
              >
              <b-form-input
                lazy
                key="key_answer_question1"
                v-model="question.answer"
                id="key_answer_question1"
                placeholder="بله عزیزم همه چی میتونی بیاری"
              />
            </b-form-group>
          </b-col>
          <b-button
            @click="removeQuestion(index)"
            variant="flat-danger"
            class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="20" />
          </b-button>
        </b-row>
        <b-row class="mb-2">
          <b-col md="3">
            <b-button @click="newQuestion"
              >افزودن سوال <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">برنامه سفر</h5>
          </b-col>
          <b-col md="12">
            <h6 for="name1" class="text-capitalize">
              تور شامل چه مواردی میشود:<span class="text-danger">*</span>
            </h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(item, index) in tourInput.include"
          :key="'includes_' + index"
        >
          <b-col key="key-question-name" md="8">
            <b-form-group>
              <b-form-input
                lazy
                key="question_name"
                v-model="tourInput.include[index]"
                id="question_name"
                placeholder="پاوربانک..."
              />
            </b-form-group>
          </b-col>

          <b-button
            @click="removeIncludes(index)"
            variant="flat-danger"
            class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="20" />
          </b-button>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button @click="newInclude"
              >افزودن <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="8" class="mt-2">
            <h6>
              تور شامل چه مواردی نمیشود
              <span class="text-danger">*</span>
            </h6>
          </b-col>
        </b-row>
        <b-row
          v-for="(item, index) in tourInput.exclude"
          :key="'excludes_' + index"
        >
          <b-col key="key-question-name" md="8">
            <b-form-group>
              <b-form-input
                lazy
                key="question_name"
                v-model="tourInput.exclude[index]"
                id="question_name"
                placeholder="سس..."
              />
            </b-form-group>
          </b-col>

          <b-button
            @click="removeExcludes(index)"
            variant="flat-danger"
            class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="20" />
          </b-button>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button @click="newExclude"
              >افزودن <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col class="mt-2" md="12"><h6>محل اقامتگاه / هتل تور</h6></b-col>
        </b-row>
        <b-row
            v-for="(space, index) in tourInput.spaces"
            :key="'spaces_' + index"
            :class="index % 2 == 0 ? 'custom-bg' : 'bg-white'"
            class="mb-2 p-2"
        >
          <b-col md="4">
            <b-form-group>
              <label for="name1" class="text-capitalize">
                آپلود تصویر شاخص محل اقامت تور:<span class="text-danger"
              >*</span
              ></label
              >
              <b-overlay :show="space.imageUploderLoading" rounded="sm">
                <div
                    id="my-strictly-unique-vue-upload-multiple-image"
                    style="display: flex; justify-content: center"
                >
                  <div
                      v-if="space.image.url && editMode"
                      class="w-100 position-relative"
                  >
                    <img
                        width="100%"
                        :src="
                        $http.defaults.fileUrl + '/uploads/' + space.image.url
                      "
                    />
                    <b-button
                        @click="removeSpaceImage(index, space.image.id)"
                        pill
                        style="left: 5px"
                        variant="danger"
                        class="font-weight-bolder position-absolute"
                        title="حذف عکس"
                    >
                      <feather-icon icon="Trash2Icon" size="20" />
                    </b-button>
                  </div>
                  <vue-upload-multiple-image
                      v-else
                      @upload-success="
                      (formData, i, fileList) =>
                        uploadSpaceImageSuccess(formData, i, fileList, index)
                    "
                      @before-remove="beforeRemove"
                      @edit-image="
                      (formData, i, fileList) =>
                        uploadSpaceImageSuccess(formData, i, fileList, index)
                    "
                      :data-images="images"
                      :idUpload="`myIdUpload` + index"
                      editUpload="myIdEdit"
                      :multiple="false"
                      browseText="انتخاب فایل"
                      markIsPrimaryText="انتخاب به عنوان عکس اصلی"
                      primaryText="عکس پیش فرض"
                      dragText="عکس ها را اینجا رها کنید"
                      popupText="این عکس به عنوان عکس اصلی انتخاب شده است"
                  ></vue-upload-multiple-image>
                </div>
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="name1" class="text-capitalize"
              >عنوان محل اقامتگاه تور:<span class="text-danger">*</span></label
              >
              <b-form-input
                  lazy
                  key="name1"
                  v-model="space.title"
                  id="name"
                  placeholder="عنوان  محل اقامتگاه تور"
              />
            </b-form-group>
            <b-form-group>
              <label for="name1" class="text-capitalize"
              >توضحیات مختصر در مورد محل اقامتگاه تور:<span class="text-danger"
              >*</span
              ></label
              >
              <b-form-input
                  lazy
                  key="name1"
                  v-model="space.description"
                  id="name"
                  placeholder="توضحیات مختصر   محل اقامتگاه تور"
              />
            </b-form-group>
            <b-form-group>
              <label for="name1" class="text-capitalize"
              >آدرس url در مورد محل اقامتگاه تور:<span class="text-danger">*</span></label
              >
              <b-form-input
                  lazy
                  key="name1"
                  v-model="space.url"
                  id="name"
                  placeholder="آدرس url در مورد محل اقامتگاه تور:"
              />
            </b-form-group>
            <b-form-group>
              <label for="name1" class="text-capitalize"
              >مدت شب  اقامت محل تور:<span class="text-danger">*</span></label
              >
              <b-form-input
                  lazy
                  key="name1"
                  v-model="space.duration"
                  id="name"
                  placeholder="مدت شب اقامت در محل تور:"
              />
            </b-form-group>
          </b-col>
          <b-button
              @click="removeSpaces(index)"
              variant="flat-danger"
              class="font-weight-bolder"
          >
            <feather-icon icon="Trash2Icon" size="40" />
          </b-button>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button variant="outline-primary" @click="newSpace" block
              >افزودن اقامتگاه <feather-icon icon="PlusIcon" size="20"
            /></b-button>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content title="برنامه سفر" icon="feather icon-map-pin" :lazy="true">
        <b-row>
          <b-col class="mt-2" md="12"><h6>برنامه تور</h6></b-col>

          <b-col
              :class="index % 2 == 0 ? 'custom-bg' : 'bg-white'"
              v-for="(value, index) in tourInput.days"
              :key="'days_' + index"
              md="12"
          >
            <b-col md="12">
              <b-form-group>
                <label for="name1" class="text-capitalize"
                >عنوان روز :<span class="text-danger">*</span></label
                >
                <b-form-input
                    lazy
                    key="name1"
                    v-model="value.dayTitle"
                    id="name"
                    placeholder="روز اول ..."
                />
              </b-form-group>
            </b-col>
            <b-row>
              <b-col
                  md="6"
                  v-for="(dayItem, dayItemIndex) in value.spaces"
                  :key="'value_spaces_' + dayItemIndex"
                  class="position-relative"
              >
                <b-row class="pt-2">
                  <b-col md="6">
                    <label :for="`myIdUpload2` + index" class="text-capitalize">
                      آپلود تصویر مراحل تور:<span class="text-danger"
                    >*</span
                    ></label
                    >
                    <b-overlay
                        :show="dayItem.imageUploaderLoading"
                        rounded="sm"
                    >
                      <div
                          v-if="dayItem.image.url && editMode"
                          class="w-100 position-relative"
                      >
                        <img
                            width="100%"
                            :src="
                            $http.defaults.fileUrl +
                            '/uploads/' +
                            dayItem.image.url
                          "
                        />
                        <b-button
                            @click="removeDaysImage(index, dayItem.image.id, dayItemIndex)"
                            pill
                            style="left: 5px"
                            variant="danger"
                            class="font-weight-bolder position-absolute"
                            title="حذف عکس"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>
                      </div>
                      <vue-upload-multiple-image
                          v-else
                          @upload-success="
                          (formData, i, fileList) =>
                            uploadDaySpaceImageSuccess(
                              formData,
                              i,
                              fileList,
                              dayItemIndex,
                              index
                            )
                        "
                          @before-remove="beforeRemove"
                          @edit-image="
                          (formData, i, fileList) =>
                            uploadDaySpaceImageSuccess(
                              formData,
                              i,
                              fileList,
                              dayItemIndex,
                              index
                            )
                        "
                          :data-images="images"
                          :idUpload="`myIdUpload2` + dayItemIndex + `_` + index"
                          editUpload="myIdEdit"
                          :multiple="false"
                          browseText="انتخاب فایل"
                          markIsPrimaryText="انتخاب به عنوان عکس اصلی"
                          primaryText="عکس پیش فرض"
                          dragText="عکس ها را اینجا رها کنید"
                          popupText="این عکس به عنوان عکس اصلی انتخاب شده است"
                      />
                    </b-overlay>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name1" class="text-capitalize"
                      >عنوان محل :<span class="text-danger">*</span></label
                      >
                      <b-form-input
                          lazy
                          key="name1"
                          v-model="dayItem.title"
                          id="name"
                          placeholder="عنوان محل "
                      />
                    </b-form-group>
                    <b-form-group>
                      <label for="name1" class="text-capitalize"
                      >توضحیات مختصر در مورد محل تور:<span class="text-danger"
                      >*</span
                      ></label
                      >
                      <b-form-input
                          lazy
                          key="name1"
                          v-model="dayItem.description"
                          id="name"
                          placeholder="توضحیات مختصر تور"
                      />
                    </b-form-group>
                    <b-form-group>
                      <label for="name1" class="text-capitalize"
                      >آدرس url در مورد تور:<span class="text-danger"
                      >*</span
                      ></label
                      >
                      <b-form-input
                          lazy
                          key="name1"
                          v-model="dayItem.blog_url"
                          id="name"
                          placeholder="آدرس url در مورد تور:"
                      />
                    </b-form-group>
                    <b-form-group>
                      <label for="name1" class="text-capitalize"
                      >مدت زمان اجرای محل تور:<span class="text-danger"
                      >*</span
                      ></label
                      >
                      <b-form-input
                          lazy
                          key="name1"
                          v-model="dayItem.duration"
                          id="name"
                          placeholder="مدت زمان اجرای محل تور:"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button
                    @click="removeDaySpace(dayItemIndex, index)"
                    variant="flat-danger"
                    style="top: 0; left: 0"
                    class="font-weight-bolder position-absolute"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
              </b-col>
            </b-row>
            <b-col md="3">
              <b-button @click="newDayspace(index)"
              >افزودن محل <feather-icon icon="PlusIcon" size="20"
              /></b-button>
            </b-col>
            <hr />
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-button
                class="w-100"
                @click="newDay"
                block
                variant="outline-primary"
            >افزودن روز <feather-icon icon="PlusIcon" size="20"
            /></b-button> </b-col
          ></b-row>
      </tab-content>

      <!-- social link -->
      <!--      <tab-content
        :before-change="beforeTab5Switch"
        title="قیمت گذاری (تومان)"
        icon="feather icon-link"
        :lazy="true"
      >
        <b-row>
          <b-col cols="6" class="mb-2">
            <h5 class="mb-0">قیمت گذاری</h5>
            <small class="text-muted"
              >نحوه قیمت گذاری و قیمت ها را وارد کنید.</small
            >

            <b-row>
              <b-col cols="6" class="mb-2">
                <b-form-group label="انتخاب تاریخ رفت">
                  <b-form-input
                    lazy
                    :formatter="formatnumber"
                    v-model="tourInput.prices.normal_dayes"
                    placeholder="1402-10-12"
                    size="sm"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="انتخاب تاریخ برگشت">
                  <b-form-input
                    lazy
                    :formatter="formatnumber"
                    v-model="tourInput.prices.weekend_days"
                    placeholder="1402-10-12"
                    size="sm"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group label="حداکثر ظرفیت">
                  <b-form-input
                    lazy
                    :formatter="formatnumber"
                    v-model="tourInput.prices.peack_days"
                    placeholder="مثال: 10"
                    size="sm"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group
                  v-if="tourInput.prices.priceType !== 'pricePerPerson'"
                  label="هزینه به ازای هر فرد"
                >
                  <b-form-input
                    lazy
                    :formatter="formatnumber"
                    v-model="tourInput.prices.extra_guest"
                    placeholder="مثال: 50000"
                    size="sm"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6" class="mb-2">
                <b-form-group>
                  <b-form-checkbox
                      :label="tourInput.prices.pricePerBaby.name"
                      v-model="tourInput.prices.pricePerBaby.hasPrice"
                  >
                    هزینه به ازای هر نوزاد
                  </b-form-checkbox>
                  <b-form-input
                      lazy
                      size="sm"
                      :formatter="formatnumber"
                      :disabled="!tourInput.prices.pricePerBaby.hasPrice"
                      v-model="tourInput.prices.pricePerBaby.price"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-col key="key-name" md="3">
                  <b-button>افزودن قیمت</b-button>
                </b-col>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="d-flex justify-content-between" md="12">
            <h5 class="mb-0 w-auto">خدمات ویژه</h5>
            <b-form-spinbutton
              v-model="specialServices"
              inline
              min="0"
              max="20"
              size="sm"
            ></b-form-spinbutton>
          </b-col>
          <template>
            <b-row
              v-for="(value, key, index) in tourInput.special_services"
              :key="key"
            >
              <b-col v-if="index > 0" cols="3" class="mb-2">
                <b-form-group label="عنوان" label-for="min-night-input">
                  <b-form-input
                    lazy
                    size="sm"
                    id="min-night-input"
                    v-model="value.name"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="index > 0" cols="3" class="mb-2">
                <b-form-group label="هزینه" label-for="min-night-input">
                  <b-form-input
                    lazy
                    size="sm"
                    :formatter="formatnumber"
                    id="min-night-input"
                    v-model="value.price"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="index > 0" cols="3" class="mb-2">
                <b-form-group label="شیوه ارائه" label-for="min-night-input">
                  <b-form-select
                    v-model="value.method"
                    :options="methodss"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="index > 0" cols="3" class="mb-2">
                <b-form-checkbox
                  :label="value.name"
                  v-model="value.perPerson"
                  :id="`${value.name}_${index}`"
                  >به ازای هر نفر</b-form-checkbox
                >
              </b-col>
            </b-row>
          </template>
        </b-row>
      </tab-content>-->

      <tab-content title="مدیا" icon="feather icon-link" :lazy="true">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">آپلود عکس ها و فیلم</h5>
            <small class="text-muted"> عکس ها و ویدئوی تور را آپلود کنید</small>
          </b-col>
          <b-col
            style="position: relative"
            md="4"
            v-for="image in tourInput.images"
            :key="'tourInput_images_' + image.id"
            class="p-2"
          >
            <img
              width="100%"
              :src="$http.defaults.fileUrl + '/uploads/' + image.path.original"
            />
            <b-button
              type="danger"
              icon
              size="sm"
              style="position: absolute; left: 0; top: 0"
              @click="deleteImage(image, tourInput.id)"
            >
              <BIconTrash></BIconTrash>
            </b-button>
          </b-col>
          <b-col md="6" lg="4" sm="12">
            <vue-upload-multiple-image
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @mark-is-primary="markIsPrimary"
              @edit-image="editImage"
              :data-images="images"
              idUpload="myIdUpload"
              :maxImage="60"
              browseText="انتخاب فایل"
              markIsPrimaryText="انتخاب به عنوان عکس اصلی"
              primaryText="عکس پیش فرض"
              dragText="عکس ها را اینجا رها کنید"
              popupText="این عکس به عنوان عکس اصلی انتخاب شده است"
              ref="imageUploader"
            ></vue-upload-multiple-image>
          </b-col>
          <b-col cols="6" class="mb-2">
            <b-form-group
              label=" لینک فیلم را با کاما (,) جداسازی نمایید"
              label-for="min-night-input"
            >
              <b-form-textarea
                lazy
                size="sm"
                id="min-night-input"
                v-model="tourInput.videos"
              />
            </b-form-group>
            <b-form-group label="لینک پادکست تور" label-for="min-night-input">
              <b-form-textarea
                lazy
                size="sm"
                id="min-night-input"
                v-model="tourInput.podcasts"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content
        title="تنظیمات سئو (SEO)"
        icon="feather icon-link"
        :lazy="true"
      >
        <b-row>
          <b-form-group class="mt-1 col-md-12">
            <label for="city_seo_data_title" class="text-capitalize">
              عنوان SEO :</label
            >
            <b-form-input
              lazy
              id="name"
              v-model="tourInput.seo_data_title"
              type="text"
            />
          </b-form-group>

          <b-form-group class="mt-1 col-md-12">
            <label for="seo_data_keywords" class="text-capitalize">
              کلمات کلیدی (با "،" جدا شود) :
            </label>
            <b-form-textarea
              lazy
              rows="1"
              id="seo_data_keywords"
              v-model="tourInput.seo_data_keywords"
              type="text"
            />
          </b-form-group>
          <b-form-group class="mt-1 col-md-12">
            <label for="seo_data_description" class="text-capitalize"
              >توضیجات SEO:</label
            >
            <b-form-textarea
              lazy
              rows="4"
              id="seo_data_description"
              v-model="tourInput.seo_data_description"
              type="text"
            />
          </b-form-group>
          <b-form-group class="mt-1 col-md-12">
            <label for="seo_data_schema" class="text-capitalize"
              >schema SEO:</label
            >
            <b-form-textarea
              lazy
              rows="4"
              id="seo_data_schema"
              v-model="tourInput.seo_data_schema"
              type="text"
            />
          </b-form-group>
        </b-row>
      </tab-content>
      <!-- <button >ثبت</button> -->
      <b-button slot="finish" variant="primary">
        <div v-if="submitLoading" class="px-1">
          <b-spinner small style="width: 1.3rem; height: 1.3rem" />
          <span class="sr-only">Loading...</span>
        </div>
        <span v-else class="text-capitalize">
          {{ $t("submit") }}
        </span>
      </b-button>
      <b-progress :value="imageUploadPercentage" class="mb-3"></b-progress>
    </form-wizard>
  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTimepicker,
  BFormTextarea,
  BFormSpinbutton,
  BFormCheckbox,
  BFormRadio,
  BBadge,
  BButton,
  BSpinner,
  BProgress,
  BFormRadioGroup,
  BIconTrash,
  BFormSelect,
  BOverlay,
} from "bootstrap-vue";
import { codeIconInfo } from "@/components/code";
import "vue-select/dist/vue-select.css";
import { VueEditor } from "vue2-editor";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";

import { Icon } from "leaflet";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { forEach } from "postcss-rtl/lib/affected-props";
import QuillEditor from "vue-quill-editor/src/editor.vue";
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  components: {
    QuillEditor,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormTimepicker,
    VueEditor,
    BFormTextarea,
    BFormSpinbutton,
    BFormCheckbox,
    BFormRadio,
    BBadge,
    VueUploadMultipleImage,
    BButton,
    BSpinner,
    BProgress,
    BFormRadioGroup,
    BIconTrash,
    BFormSelect,
    BOverlay,
  },
  props: ["provinces", "countries"],
  data() {
    return {
      Selected: "A",
      selectedRule: {},
      addRules: false,
      addRegulations: false,
      addPackages: false,
      helperRegulation: [],
      helperPackage: [],
      methodss: [
        { value: "daily", text: "روزانه" },
        { value: "oneTime", text: "یکبار" },
      ],
      dates: null,
      now: new Date(),
      editMode: false,
      residenceIndex: null,
      imageUploadPercentage: 0,
      images: [],
      imagesHelper: [],
      thirdImagesHelper: [],
      specialServices: 0,
      bedrooms: 0,
      tour_style: ["گروهی", "خانوادگی", "vip"],
      tour_type: ["خارجی", "داخلی"],
      tour_ages: [
        "از 7 سال تا 60 سال",
        "از 1 سال 80 سال ",
        "از 18 تا 40 سال ",
        "از 12 تا 20 سال",
      ],
      tour_difficulty: ["1 از 5 ", "2 از 5 ", "3 از 5 ", "4 از 5 ", "5 از 5 "],
      tour_transportation: [
        "هواپیما ",
        "اتوبوس",
        "قطار ",
        "سواری ",
        "زمینی ، هوایی  ",
      ],
      owners: [],
      autoimmunePackagesItemArray: [],
      regulationsItemArray: [],
      rulesItemArray: [],
      packagesItemArray: [],
      categoriesItemArray: [],
      health_itemsItemArray: [],
      categories: [],
      ages: [],
      health_items: [],

      rules: [],
      showMap: true,
      showDestinationMap: true,
      showOriginMap: true,

      lat: 29.591768,
      lng: 52.583698,
      zoom: 17,
      zoomDestination: 17,
      center: latLng(29.591768, 52.583698),
      centerDestination: latLng(29.591768, 52.583698),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 17,
      currentZoomDestination: 17,
      currentCenter: latLng(29.591768, 52.583698),
      currentCenterDestination: latLng(29.591768, 52.583698),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showGettingCityLoading: false,
      showGettingCityLoadingDestination: false,
      showGettingCityLoadingOrigin: false,
      showGettingCapitalLoading: false,
      cities: [],
      citiesDestination: [],
      citiesOrigin: [],
      locationSetion: "",

      capitals: [],
      destinationCapitals:[],
      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],

      locale: "Tehran",
      labels: {
        Tehran: {
          labelHours: "ساعت",
          labelMinutes: "دقیقه",
          labelSeconds: "ثایه",
          labelAmpm: "صبح ظهر",
          labelAm: "ص",
          labelPm: "ظ",
          labelIncrement: "زيادة",
          labelDecrement: "إنقاص",
          labelSelected: "زمان انتخاب شده",
          labelNoTimeSelected: "زمان انتخاب نشده است",
          labelCloseButton: "بستن",
        },
      },
      tourInput: {
        id: "",
        name: "",
        slug: "",
        host_id: "",
        category_id: "",
        age_id: "",
        tour_style: "",
        tour_difficulty: "",
        tour_transportation: "",
        min_day_before_reservation: "",
        min_people: "",
        max_people: "",
        price: "",
        score: "",

        description: "",
        visa_description: "",
        transfer_description: "",
        covid: "",
        blog_url: "",
        state_id: "",
        city_id: "",
        country_id: "",
        capital_id: "",
        lat_origin: "",
        lng_origin: "",
        lat_destination: "",
        lng_destination: "",
        show_index_page: "",
        address_origin: "",
        address_destination: "",
        days: {
          dayTitle: "روز جدید",
          spaces: [
            {
              title: "",
              description: "",
              image: "",
              blog_url: "ee",
              duration: "",
            },
          ],
        },
        include: [],
        exclude: [],
        faqs: [],
        spaces: [],
        rules: [],

        images: [],

        commission_per_person: "",
        commission_per_group: "",
        show_order_number: "",
        seo_data_title: "",
        seo_data_keywords: "",
        seo_data_description: "",
        seo_data_schema: "",
        videos: "",
        podcasts: "",
        status: "active",
        close_booking: "active",
        //start location
        tour_origin_position: "داخلی",
        state_id: "",
        city_id: "",
        country_id: "",
        capital_id: "",

        tour_destination_position: "داخلی",
        state_destination_id: "",
        city_destination_id: "",
        capital_destination_id: "",
        country_destination_id: "",

        //end location
      },
      selectedContry: "select_value",
      selectedLanguage: "nothing_selected",
      codeIconInfo,

      submitLoading: false,
    };
  },
  mounted() {
    const endofMonth = this.$moment(this.date).endOf("month");
    const toDate = this.$moment(endofMonth).add(6, "months").endOf("month");
    const endofMonth1 = this.$moment(this.date);
    const toDate1 = this.$moment(endofMonth).endOf("month");
    console.log(endofMonth1.format("YYYY/MM/DD"), toDate1.format("YYYY/MM/DD"));
    this.getOwners();
    // this.getResidencesPrerequisite(
    //   "autoimmunePackagesItemArray",
    //   "autoimmune_packages",
    //   "autoimmune_packages"
    // );
    // this.getResidencesPrerequisite(
    //   "regulationsItemArray",
    //   "regulations",
    //   "regulations"
    // );
    // this.getResidencesPrerequisite("rulesItemArray", "rules", "rules");
    // this.getResidencesPrerequisite("packagesItemArray", "packages", "packages");
    // this.getResidencesPrerequisite(
    //   "categoriesItemArray",
    //   "categories",
    //   "categories"
    // );
    // this.getResidencesPrerequisite(
    //   "health_itemsItemArray",
    //   "health_items",
    //   "health_items"
    // );
    this.$nextTick(() => {
      this.$refs.mymap.mapObject._onResize();
      this.$refs.mymapDestination.mapObject._onResize();
    });
  },
  watch: {
    specialServices(newVal, oldVal) {
      if (newVal == oldVal) {
        this.tourInput.special_services = {
          ...this.tourInput.special_services,
        };
      }
      if (newVal == 0) {
        this.tourInput.special_services = { 0: null };
      } else if (newVal > oldVal && newVal !== 0) {
        if (this.tourInput.special_services[newVal]) {
          this.tourInput.special_services = {
            ...this.tourInput.special_services,
          };
        } else {
          this.tourInput.special_services[newVal] = {
            name: "",
            price: "",
            method: "",
            perPerson: false,
          };
        }
      } else if (newVal < oldVal && newVal !== 0) {
        delete this.tourInput.special_services[oldVal];
      } else if (newVal == oldVal) {
      }
      console.log("special_services:", this.tourInput.special_services);
    },
    bedrooms(newVal, oldVal) {
      if (newVal == oldVal) {
        this.tourInput.rooms = { ...this.tourInput.rooms };
      }
      if (newVal == 0) {
        this.tourInput.rooms = {
          0: {
            roomNumber: 0,
            single: 0,
            double: 0,
            kaf_khab: 0,
            description: "",
          },
        };
      } else if (newVal > oldVal && newVal !== 0) {
        if (this.tourInput.rooms[newVal]) {
          this.tourInput.rooms = { ...this.tourInput.rooms };
        } else {
          if (newVal == 1) {
            var x = this.tourInput.rooms["0"];
            this.tourInput.rooms = {};
            this.tourInput.rooms["1"] = {
              roomNumber: 1,
              single: x.single,
              double: x.double,
              kaf_khab: x.kaf_khab,
              description: x.description,
            };
          } else {
            this.tourInput.rooms[newVal] = {
              roomNumber: newVal,
              single: 0,
              double: 0,
              kaf_khab: 0,
              description: "",
            };
          }
        }
      } else if (newVal < oldVal && newVal !== 0) {
        if (newVal == 1) {
          var x = this.tourInput.rooms["1"];
          this.tourInput.rooms = {};
          this.tourInput.rooms["1"] = x;
        } else {
          delete this.tourInput.rooms[newVal];
        }
      } else if (newVal == oldVal) {
      }
      console.log("rooms:", this.tourInput.rooms);
    },
  },
  methods: {
    removeSpaceImage(index, imageId) {
      this.tourInput.spaces[index].image = { url: null, id: null };
    },
    removeDaysImage(dayIndex, imageId, spaceIndex) {
      if (
          this.tourInput.days &&
          this.tourInput.days[dayIndex] &&
          this.tourInput.days[dayIndex].spaces &&
          this.tourInput.days[dayIndex].spaces[spaceIndex]
      ) {
        this.$set(
            this.tourInput.days[dayIndex].spaces[spaceIndex],
            'image',
            { url: null, id: null }
        );
        // You can also make an API call to delete the image if needed
        // axios.delete(`/api/images/${imageId}`)
      }
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    beforeTab1Switch() {
      // if (this.submitLoading) return false;
      // let errorMessage = null;
      // if (!errorMessage && !this.tourInput.name) {
      //   errorMessage = "لطفا نام تور را وارد کنید";
      // }
      // if (!errorMessage && !this.tourInput.slug) {
      //   errorMessage = "لطفا اسلاگ تور را وارد کنید";
      // }
      // if (!errorMessage && !this.tourInput.host_id) {
      //   errorMessage = "لطفا میزبان را انتخاب کنید";
      // }
      // if (!errorMessage && !this.tourInput.category_id) {
      //   errorMessage = "لطفا دسته بندی را انتخاب کنید";
      // }

      // if (errorMessage) {
      //   this.$bvToast.toast(errorMessage, {
      //     title: this.$t("Error"),
      //     variant: "danger",
      //     solid: true,
      //   });
      //   return false;
      // }
      return true;
    },
    searchLatLng() {
      this.center = latLng(this.tourInput.lat, this.tourInput.lng);
    },
    beforeTab5Switch() {
      // if (this.submitLoading) return false;
      // let errorMessage = null;
      // if (!errorMessage && !this.tourInput.prices.normal_dayes) {
      //   errorMessage = "لطفا قیمت روزهای عادی را وارد کنید";
      // }

      // if (!errorMessage && !this.tourInput.prices.weekend_days) {
      //   errorMessage = "لطفا قیمت آخر هفته را وارد کنید";
      // }
      // if (!errorMessage && !this.tourInput.prices.peack_days) {
      //   errorMessage = "لطفا قمیت روزهای پیک را انتخاب کنید";
      // }

      // if (errorMessage) {
      //   this.$bvToast.toast(errorMessage, {
      //     title: this.$t("Error"),
      //     variant: "danger",
      //     solid: true,
      //   });
      //   return false;
      // }
      // this.sliderShown();
      return true;
    },
    beforeTab2Switch() {
      // if (this.submitLoading) return false;
      // let errorMessage = null;
      // if (!errorMessage && !this.tourInput.state_id) {
      //   errorMessage = "لطفا استان تور را وارد کنید";
      // }
      // if (!errorMessage && !this.tourInput.city_id) {
      //   errorMessage = "لطفا شهر تور را وارد کنید";
      // }
      // if (!errorMessage && !this.tourInput.address) {
      //   errorMessage = "لطفا آدرس دقیق تور را وارد کنید";
      // }
      // if (
      //   !errorMessage &&
      //   !this.tourInput.lat &&
      //   !this.tourInput.lng
      // ) {
      //   errorMessage = "لطفا لوکیشن را روی نقشه انتخاب کنید";
      // }

      // if (errorMessage) {
      //   this.$bvToast.toast(errorMessage, {
      //     title: this.$t("Error"),
      //     variant: "danger",
      //     solid: true,
      //   });
      //   return false;
      // }
      console.log(
          "lat,lng:",
          this.tourInput.lat_origin,
          this.tourInput.lng_origin
      );
      return true;
    },
    beforeTab3Switch() {
      // var packages = [];
      // this.packagesItemArray.forEach((element) => {
      //   if (element.disable == true) {
      //     packages.push({
      //       residence_packages_id: element.id,
      //       disable: 1,
      //       ownerDescription: element.ownerDescription,
      //     });
      //   }
      // });

      // console.log("regulations", packages);
      // if (this.submitLoading) return false;
      // let errorMessage = null;
      // if (!errorMessage && !this.tourInput.rules) {
      //   errorMessage = "لطفا قانون لغو رزرو تور را وارد کنید";
      // }

      // if (errorMessage) {
      //   this.$bvToast.toast(errorMessage, {
      //     title: this.$t("Error"),
      //     variant: "danger",
      //     solid: true,
      //   });
      //   return false;
      // }
      return true;
    },
    uploadImageSuccess(formData, index, fileList) {
      console.log("formData", formData);
      // console.log('formData.keys()', formData.values())

      for (const value of formData.values()) {
        this.thirdImagesHelper.push(value);

      }
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    removeImage(k, imageId, dayItemIndex) {
      const requestData = {
        method: "delete",
        url: `/admin/medias/` + imageId,

        // config: config,
      };
      var vm = this;
      if (dayItemIndex) {
        this.tourInput.days[k].spaces[dayItemIndex].imageUploaderLoading = true;
      } else {
        this.tourInput.spaces[k].imageUploderLoading = true;
      }
      this.$http(requestData)
          .then((response) => {
            if (dayItemIndex) {
              vm.tourInput.days[k].spaces[
                  dayItemIndex
                  ].imageUploaderLoading = false;
              vm.tourInput.days[k].spaces[
                  dayItemIndex
                  ]["image"]["url"] =""
              vm.tourInput.days[k].spaces[
                  dayItemIndex
                  ]["image"]["id"] =""
            } else {
              vm.tourInput.spaces[k]["image"]["url"] = "";
              vm.tourInput.spaces[k]["image"]["id"] = "";
              vm.tourInput.spaces[k].imageUploderLoading = false;
            }


            // return true;
          })
          .catch((err) => {
            if (dayItemIndex) {
              vm.tourInput.days[k].spaces[
                  dayItemIndex
                  ].imageUploaderLoading = false;
            } else {
              vm.tourInput.spaces[k].imageUploderLoading = false;
            }
            // return false;
          });
    },
    uploadSpaceImageSuccess(formData, index, fileList, k) {
      console.log("data", formData, index, fileList, k);
      // console.log('formData.keys()', formData.values())
      for (const value of formData.values()) {
        this.imagesHelper.push(value);
        console.log(this.imagesHelper);
      }

      let toUploadformData = new FormData();
      this.imagesHelper.forEach((image, index) => {
        toUploadformData.append(`file`, image);
      });

      // const config = {
      //   //Choose upload
      //   onUploadProgress: (progressEvent) => {
      //     const { loaded, total } = progressEvent;
      //     this.imageUploadPercentage = Math.floor((loaded * 100) / total);

      //     if (this.imageUploadPercentage < 100) {
      //       console.log(this.imageUploadPercentage);
      //     }
      //   },
      // };
      const requestData = {
        method: "post",
        url: `/admin/medias`,
        data: toUploadformData,
        // config: config,
      };
      var vm = this;
      this.tourInput.spaces[k].imageUploderLoading = true;
      this.$http(requestData, formData)
          .then((response) => {
            console.log(response);
            vm.tourInput.spaces[k].imageUploderLoading = false;

            vm.tourInput.spaces[k]["image"]["url"] =
                response.data.data.files.original;
            vm.tourInput.spaces[k]["image"]["id"] = response.data.data.id;

            // return true;
          })
          .catch((err) => {
            console.log("falseeee");
            this.tourInput.spaces[k].imageUploderLoading = false;
            // return false;
          });
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: "Form Submitted",
      //     icon: "EditIcon",
      //     variant: "success",
      //   },
      // });

      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },

    uploadDaySpaceImageSuccess(formData, index, fileList, dayItemIndex, k) {
      for (const value of formData.values()) {
        this.imagesHelper.push(value);
        console.log(this.imagesHelper);
      }

      let toUploadformData = new FormData();
      this.imagesHelper.forEach((image, index) => {
        toUploadformData.append(`file`, image);
      });

      // const config = {
      //   //Choose upload
      //   onUploadProgress: (progressEvent) => {
      //     const { loaded, total } = progressEvent;
      //     this.imageUploadPercentage = Math.floor((loaded * 100) / total);

      //     if (this.imageUploadPercentage < 100) {
      //       console.log(this.imageUploadPercentage);
      //     }
      //   },
      // };
      const requestData = {
        method: "post",
        url: `/admin/medias`,
        data: toUploadformData,
        // config: config,
      };
      var vm = this;
      this.tourInput.days[k].spaces[dayItemIndex].imageUploaderLoading = true;
      this.$http(requestData, formData)
          .then((response) => {
            console.log(response);
            vm.tourInput.days[k].spaces[
                dayItemIndex
                ].imageUploaderLoading = false;

            vm.tourInput.days[k].spaces[dayItemIndex]["image"]["url"] =
                response.data.data.files.original;
            vm.tourInput.days[k].spaces[dayItemIndex]["image"]["id"] =
                response.data.data.id;

            // return true;
          })
          .catch((err) => {
            console.log("falseeee");
            vm.tourInput.days[k].spaces[
                dayItemIndex
                ].imageUploaderLoading = false;
            // return false;
          });
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: "Form Submitted",
      //     icon: "EditIcon",
      //     variant: "success",
      //   },
      // });

      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },

    beforeRemove(index, done, fileList) {
      console.log("index", index, fileList);
      var r = confirm("remove image");
      if (r == true) {
        done();

        this.imagesHelper.splice(index, 1);
        console.log(this.imagesHelper);
      } else {
      }
    },
    editImage(formData, index, fileList) {
      console.log("edit data", formData, index, fileList);
      for (const value of formData.values()) {
        this.imagesHelper[index] = value;
        console.log(this.imagesHelper);
      }
    },
    markIsPrimary(index, fileList) {
      console.log("index", index);

      const fromIndex = index;
      const toIndex = 0;

      const element = this.imagesHelper.splice(fromIndex, 1)[0];

      this.imagesHelper.splice(toIndex, 0, element);
      console.log("this.imagesHelper", this.imagesHelper);
    },
    onComplete() {
      alert("helowww");
    },
    changeBedrooms($event) {},
    async getOwners() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  "filter[name]": this.selectedFilter.include("name")
        //     ? this.searchInput
        //     : "",
        //   "filter[email]": this.selectedFilter.include("email")
        //     ? this.searchInput
        //     : "",
        //   "filter[mobile]": this.selectedFilter.include("mobile")
        //     ? this.searchInput
        //     : "",
        per_page: 5000,
        //   page: this.page,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/host",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.owners = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
    },
    changeee($event, index) {
      console.log("value", this.packages, $event, index);
      this.$set(this.packages, index, $event.target._value);
    },
    async getResidencesPrerequisite(stateNameHelper, stateName, url) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false, // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/tours/${url}`,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      await this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this[stateName] = data.data;
            this[stateName].forEach((element) => {
              element["disable"] = false;
              element["ownerDescription"] = "";
            });
            //           this.packagesItemArray= [
            //   {
            // name: "ACC",
            // ownerDescription: 10,
            // disable: true,
            //   }
            // ],
            this[stateName].forEach((element, index) => {
              this[stateNameHelper].push({
                name: "ACC",
                ownerDescription: 10,
                disable: true,
              });
              Object.keys(element).forEach((element2, index2) => {
                this[stateNameHelper][index][element2] = element[element2];
              });

              // this[stateNameHelper][index].concat(this[stateName][index]);
              this[stateNameHelper][index]["name"] = element.name;
              this[stateNameHelper][index]["ownerDescription"] =
                  element.ownerDescription;
              this[stateNameHelper][index]["disable"] = element.disable;
            });
            this.$store.commit(
                `app/UPDATE_RESIDENCE_DATA_${stateName}`,
                this[stateNameHelper]
            );
            console.log(stateNameHelper, this[stateNameHelper]);
          })
          .catch((err) => {
            console.log(err);
          });
    },

    addNewfield($event, index) {
      console.log("tourInput.packages:", $event, index);
      if (!$event) {
        // this.$set(this.this.tourInput.packages[index], ownerDescription, "");
      } else {
        this.tourInput.packages[index]["ownerDescription"] = $event;
        //  this.$set(this.tourInput.packages[index], 'ownerDescription', $events);
        console.log("tourInput.packages:", this.tourInput.packages);
      }
    },
    sliderShown() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.mymap.mapObject._onResize();
        this.$refs.mymapDestination.mapObject._onResize();
      }, 100);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
      console.log("this.$refs.mymap:", this.$refs.mymap);
      this.$refs.mymap.mapObject._onResize();
    },
    zoomUpdateDestination(zoomDestination) {
      this.currentZoomDestination = zoomDestination;
      console.log("this.$refs.mymapDestination:", this.$refs.mymapDestination);
      this.$refs.mymapDestination.mapObject._onResize();
    },

    centerUpdate(center) {
      this.currentCenter = center;

      console.log("center", center);
      this.tourInput.lat_origin = center.lat;
      this.tourInput.lng_origin = center.lng;
      // this.center = latLng(this.tourInput.lat, this.tourInput.lng);
    },
    centerUpdateDestination(centerDestination) {
      this.currentCenterDestination = centerDestination;

      console.log("center", centerDestination);
      this.tourInput.lat_destination = centerDestination.lat;
      this.tourInput.lng_destination = centerDestination.lng;
      // this.center = latLng(this.tourInput.lat, this.tourInput.lng);
    },
    onResize() {
      console.log("this.$refs.mymap:", this.$refs.mymap);
      this.$refs.mymap.mapObject._onResize();
      this.$refs.mymapDestination.mapObject._onResize();
    },
    getSelectedProvincesCity(provinceId, section) {
      console.log(provinceId, section);
      this.locationSetion = section;
      if (section == "destinationMode") {
        this.showGettingCityLoadingDestination = true;
      } else if (section == "originMode") {
        this.showGettingCityLoadingOrigin = true;
      }

      this.getCityByProvinceId(provinceId,section);
    },
    async getCityByProvinceId(provinceId,section) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/cities/${provinceId}`,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;

            if (this.locationSetion == "destinationMode" || section=="destinationMode") {
              this.citiesDestination = data.data;
              this.paginationData = data.meta;
              this.showGettingCityLoadingDestination = false;
              if (!this.editMode) {
                this.tourInput.city_destination_id =
                    this.citiesDestination[0]["id"];
              }
              console.log(" this.citiesDestination:", this.citiesDestination);
            } else if (this.locationSetion == "originMode" || section=="originMode") {
              this.citiesOrigin = data.data;
              this.paginationData = data.meta;
              this.showGettingCityLoadingOrigin = false;
              if (!this.editMode) {
                this.tourInput.city_id = this.citiesOrigin[0]["id"];
              }
              console.log(" this.citiesOrigin:", this.citiesOrigin);
            }
          })
          .catch((err) => {
            console.log(err);
            this.showGettingCityLoadingDestination = false;
            this.showGettingCityLoadingOrigin = false;
          });
    },

    getSelectedCountriesCity(countryId,section) {
      this.showGettingCapitalLoading = true;
      this.getCapitalByCountryId(countryId,section);
    },
    async getCapitalByCountryId(countryId,section) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/capitals/${countryId}`,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            if ( section=="originMode") {
              let data = response.data;
              this.capitals = data.data;
              this.paginationData = data.meta;
              this.showGettingCapitalLoading = false;
              if (!this.editMode) {
                this.tourInput.capital_id = this.capitals[0]["id"];
              }
            }
            else if(section=="destinationMode"){
              let data = response.data;
              this.destinationCapitals = data.data;
              this.paginationData = data.meta;
              this.showGettingCapitalLoading = false;
              if (!this.editMode) {
                this.tourInput.capital_destination_id = this.destinationCapitals[0]["id"];
              }

            }
          })
          .catch((err) => {
            console.log(err);
            this.showGettingCityLoading = false;
          });
    },

    onContext(ctx) {
      this.context = ctx;
    },


    deFormatePrices(prices, type) {
      if (type == "prices") {
        var formatedPrices = prices;
        if (prices.normal_dayes)
          formatedPrices.normal_dayes = this.deFormatnumber(
              prices.normal_dayes
          );
        if (prices.weekend_days)
          formatedPrices.weekend_days = this.deFormatnumber(
              prices.weekend_days
          );
        if (prices.peack_days)
          formatedPrices.peack_days = this.deFormatnumber(prices.peack_days);
        if (prices.extra_guest)
          formatedPrices.extra_guest = this.deFormatnumber(prices.extra_guest);
        if (prices.pricePerBaby.price)
          formatedPrices.pricePerBaby.price = this.deFormatnumber(
              prices.pricePerBaby.price
          );
        if (prices.pricePerAnimal.price)
          formatedPrices.pricePerAnimal.price = this.deFormatnumber(
              prices.pricePerAnimal.price
          );
        return formatedPrices;
      } else {
        var formatedSpecial_services = prices;
        if (prices && prices[0] !== null)
          Object.keys(prices).forEach((element) => {
            formatedSpecial_services[element].price = this.deFormatnumber(
                prices[element].price
            );
          });

        return formatedSpecial_services;
      }
    },


    deFormatPrices2(price) {
      return  price = this.deFormatnumber(this.tourInput.price);
    },

    deFormatnumber(value) {
      console.log("deforamt:", value);
      var a = value;
      a = a.replace(/\,/g, ""); // 1125, but a string, so convert it to number
      a = parseInt(a, 10);
      return a;
    },
    createTestCalender(id) {
      console.log(this.saveCourierCalendars(id));
    },
    saveCourierCalendars(id) {
      // console.log({ data: this.getDatesFromStartTo6Month() });
      const requestData = {
        method: "post",
        url: `/admin/residence/calendars/${id}`,
        data: { calendars: this.getDatesFromStartTo6Month(id) },
      };

      this.$http(requestData)
          .then(async (response) => {
            // console.log(response)
            let message = "تقویم تور با موفقیت ایجاد شد";
            if (this.editMode) message = "تور با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
          })
          .catch((err) => {
            let message = "خطا در ایجاد تفویم تور";
            if (this.editMode) message = "خطا در ویرایش تقویم تور";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: "Form Submitted",
      //     icon: "EditIcon",
      //     variant: "success",
      //   },
      // });
    },
    monthsBetweenDates(startDate, endDate, id) {
      const now = startDate,
          dates = [];
      console.log("startDate:", startDate, "endDate:", endDate);
      while (now.isSameOrBefore(endDate)) {
        console.log("now", now, now.isoWeekday());
        if (now.isoWeekday() === 3) {
          // console.log(now.format("dddd"));
          // console.log('now',now,now.weekday());
          dates.push({
            residence_id: id,
            date: now.locale("en").format("YYYY-MM-DD"),
            price: this.tourInput.prices.weekend_days,
            instant: null,
            discount: null,
            minNight: null,
            isWeakened: 1,
            books_count: 0,
            disable_count: 0,
            is_custom_price: 0,
            extra_guest_price: null,
          });
        } else if (now.isoWeekday() === 4) {
          // console.log(now.format("dddd"));
          // console.log('now',now,now.weekday());
          dates.push({
            residence_id: id,
            date: now.locale("en").format("YYYY-MM-DD"),
            price: this.tourInput.prices.weekend_days,
            instant: null,
            discount: null,
            minNight: null,
            isWeakened: 1,
            books_count: 0,
            disable_count: 0,
            is_custom_price: 0,
            extra_guest_price: null,
          });
        } else {
          dates.push({
            residence_id: id,
            date: now.locale("en").format("YYYY-MM-DD"),
            price: this.tourInput.prices.normal_dayes,
            instant: null,
            discount: null,
            minNight: null,
            isWeakened: 0,
            books_count: 0,
            disable_count: 0,
            is_custom_price: 0,
            extra_guest_price: null,
          });
        }

        now.add(1, "days");
      }
      return dates;
    },
    getDatesFromStartTo6Month(id) {
      // console.log(this.$moment)
      const endofMonth1 = this.$moment(this.date);
      const toDate1 = this.$moment(endofMonth).endOf("month");
      console.log(endofMonth1, toDate1);
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth1,toDate1))
      // console.log("date",this.$options.filters.moment(this.date,"jD jMMMM,jYYYY HH:mm").getDay())
      // console.log(this.$moment(this.date).endOf('month').format('YYYY/MM/D'))
      const endofMonth = this.$moment(this.date).endOf("month");
      const toDate = this.$moment(endofMonth).add(6, "months").endOf("month");

      // console.log("toDate",toDate.format('YYYY/MM/D'))
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth,toDate))
      var x = this.monthsBetweenDates(endofMonth1, toDate1, id);

      // x.splice(-1);
      var y = this.monthsBetweenDates(endofMonth, toDate, id);
      y.shift();
      // this.date.moment("jD jMMMM,jYYYY HH:mm").getDay()
      this.Dates = [...x, ...y];

      console.log(this.Dates);
      return this.Dates;
    },

    cleanRegulations() {
      var regulations = [];
      if (this.regulationsItemArray.length > 0) {
        this.regulationsItemArray.forEach((element) => {
          if (element.disable == true) {
            if (this.editMode) {
              regulations.push({
                tour_regulation_id: element.tour_regulation
                    ? element.tour_regulation.id
                    : element.id,
                disable: 1,
                ownerDescription: element.ownerDescription
                    ? element.ownerDescription
                    : null,
              });
            } else {
              regulations.push({
                tour_regulation_id: element.id,
                disable: 1,
                ownerDescription: element.ownerDescription
                    ? element.ownerDescription
                    : null,
              });
            }
          }
        });
      }
      return regulations;
    },
    cleanRules() {
      var rules = [];
      if (this.rules.length > 0) {
        this.rules.forEach((element) => {
          if (this.selectedRule.id == element.id) {
            rules.push({
              tour_rule_id: element.id,
              disable: 1,
              ownerDescription: "",
            });
          }
        });
      }
      return rules;
    },
    cleanTourInput() {
      delete this.tourInput["rules"];
    },
    async formSubmitted() {
      var rules = this.cleanRules();
      var regulations = this.cleanRegulations();
      this.cleanTourInput();
      this.submitLoading = true;
      //this.deFormatPrices2(this.tourInput.price);


      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode
            ? `/admin/tours/${this.tourInput.id}`
            : `/admin/tours`,
        data: this.tourInput,
      };
      if (this.editMode) {
        if (rules.length > 0) {
          this.submitRules(rules, this.tourInput.id);
        }
        if (regulations.length > 0) {
          this.submitRegulations(regulations, this.tourInput.id);
        }
      }

      await this.$http(requestData)
          .then(async (response) => {
            if (this.thirdImagesHelper.length > 0)
              await this.uploadImage(response.data.data.id);

            if (!this.editMode) {
              if (rules.length > 0)
                await this.submitRules(rules, response.data.data.id);
              if (regulations.length > 0)
                await this.submitRegulations(regulations, response.data.data.id);
            }

            let message = "تور با موفقیت اضافه شد";
            if (this.editMode) message = "تور با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });

            this.submitLoading = false;
            this.imagesHelper = [];
            this.images = [];
            this.imageUploadPercentage = 0;
            if (this.imagesHelper.length == 0) {
              this.getTours();
            }
          })
          .catch((err) => {
            let message = "خطا در ایجاد تور";
            if (this.editMode) message = "خطا در ویرایش تور";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          //  this.$refs.imageUploader.clear();
            this.imagesHelper = [];
            this.images = [];
            this.imageUploadPercentage = 0;
          });
    },
    getTours() {
      this.$emit("getTours");
    },
    uploadImage(id) {
      console.log('this.imagesHelper:',this.thirdImagesHelper)
      let formData = new FormData();
      this.thirdImagesHelper.forEach((image, index) => {
        formData.append(`images[${index}]`, image);
      });
      const config = {
        //Choose upload
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          this.imageUploadPercentage = Math.floor((loaded * 100) / total);

          if (this.imageUploadPercentage < 100) {
            console.log(this.imageUploadPercentage);
          }
        },
      };
      const requestData = {
        method: "post",
        url: `/admin/tours/upload_media/${id}`,
        data: formData,
        config: config,
      };

      this.$http
          .post(requestData.url, formData, config)
          .then((response) => {
            console.log("trueeeeeeee");
           // this.$refs.imageUploader.clear();
            this.thirdImagesHelper = [];
            this.images = [];
            this.getTours();

            return true;
          })
          .catch((err) => {
            console.log("falseeee");
         //   this.$refs.imageUploader.clear();
            this.thirdImagesHelper = [];
            this.images = [];
            return false;
          });
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: "Form Submitted",
      //     icon: "EditIcon",
      //     variant: "success",
      //   },
      // });
    },
    deleteImage(image, id) {
      this.$bvModal
          .msgBoxConfirm(`آیا از حذف عکس مطمئن هستید ؟  : ${image.id}.`, {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.tourInput.images = await Object.values(
                  this.tourInput.images
              ).filter((residenceItem, index) => {
                if (residenceItem.id == image.id) {
                  residenceIndex = index;
                }
                return residenceItem.id !== image.id;
              });

              const requestData = {
                method: "delete",
                url: `admin/tours/delete_media/${id}/${image.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(`عکس: ${image.id}  با موفقیت حذف شد.`, {
                      title: this.$t("Done"),
                      variant: "success",
                      solid: true,
                    });
                    this.$emit("deleteImage", image);
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.tourInput.images.splice(residenceIndex, 0, image);
                  });
            }
          });
    },
    async submitRules(rules, id) {
      this.addRules = true;
      console.log("rules,", rules);
      const requestData = {
        method: "post",
        url: `/admin/tours/rules/save/${id}`,
        data: { rules: rules },
      };
      await this.$http(requestData)
          .then((response) => {
            // console.log(response)
            let message = "قوانین لغو با موفقیت اضافه شد";
            if (this.editMode) message = "قوانین لغو با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            this.addRules = false;
            // if (this.imagesHelper.length == 0) {
            //   this.getTours();
            // }
          })
          .catch((err) => {
            this.addRules = false;
            let message = "خطا در ایجاد تور";
            if (this.editMode) message = "خطا در اضافه کردن قوانین لغو تور";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
          });
    },
    async submitRegulations(regulations, id) {
      this.addRegulations = true;
      console.log("regulations,", regulations);
      const requestData = {
        method: "post",
        url: `/admin/tours/regulations/save/${id}`,
        data: { regulations: regulations },
      };
      await this.$http(requestData)

          .then((response) => {
            // console.log(response)
            let message = "قوانین تور با موفقیت اضافه شد";
            if (this.editMode) message = "قوانین تور با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            this.addRegulations = false;
            // if (this.imagesHelper.length == 0) {
            //   this.getTours();
            // }
          })
          .catch((err) => {
            let message = "خطا در ایجاد تور";
            if (this.editMode) message = "خطا در ویرایش قوانین تور";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;
            this.addRegulations = false;
            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
          });
    },
    async submitPackages(packages, id) {
      console.log("packages,", packages);
      this.addPackages = true;
      const requestData = {
        method: "post",
        url: `/admin/tours/packages/save/${id}`,
        data: { packages: packages },
      };
      await this.$http(requestData)
          .then((response) => {
            // console.log(response)
            let message = "امکانات تور با موفقیت اضافه شد";
            if (this.editMode) message = "امکانات تور با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            this.addPackages = false;
            // if (this.imagesHelper.length == 0) {
            //   this.getTours();
            // }
          })
          .catch((err) => {
            this.addPackages = false;
            let message = "خطا در ایجاد تور";
            if (this.editMode) message = "خطا در ویرایش تور";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
          });
    },
    getSelectedCityLocaion(value) {
      console.log("city:", value);
      var index = this.cities.findIndex((item) => item.id == value);

      this.center = latLng(this.cities[index].lat, this.cities[index].lng);
    },

    // getSelectedCapitalLocaion(value) {
    //   console.log("capital:", value);
    //   var index = this.capitals.findIndex((item) => item.id == value);

    //   this.center = latLng(this.capitals[index].lat, this.capitals[index].lng);
    // },

    doSomethingOnReady() {
      this.$nextTick(() => {
        setTimeout(() => {
          //mapObject is a property that is part of leaflet
          this.$refs.mymap.mapObject._onResize();
          this.$refs.mymapDestination.mapObject._onResize();
          // this.$refs.mymap.mapObject.setZoom(11);
        }, 1000);
      });
    },

    newQuestion() {
      this.tourInput.faqs.push({ question: "", answer: "" });
      console.log(this.tourInput.faqs);
    },
    newInclude() {
      this.tourInput.include.push("");
    },
    newExclude() {
      this.tourInput.exclude.push("");
    },
    newSpace() {
      this.tourInput.spaces.push({
        image: { url: "", id: "" },
        title: "",
        description: "",
        url: "",
        duration: "",
        imageUploderLoading: false,
      });
    },
    newDay() {
      this.tourInput.days.push({
        dayTitle: "روز جدید",
        spaces: [
          {
            title: "",
            description: "",
            image: { url: "", id: "" },
            blog_url: "ee",
            duration: "",
            imageUploaderLoading: false,
          },
        ],
      });
    },

    newDayspace(index) {
      this.tourInput.days[index].spaces.push({
        title: "",
        description: "",
        image: { url: "", id: "" },
        blog_url: "ee",
        duration: "",
        imageUploaderLoading: false,
      });
    },
    removeQuestion(index) {
      this.tourInput.faqs.splice(index, 1);
    },

    removeExcludes(index) {
      this.tourInput.exclude.splice(index, 1);
    },
    removeIncludes(index) {
      this.tourInput.include.splice(index, 1);
    },
    removeSpaces(index) {
      this.tourInput.spaces.splice(index, 1);
    },
    removeDaySpace(dayItemIndex, index) {
      this.tourInput.days[index].spaces.splice(dayItemIndex, 1);
    },
    onClickOutsideDestinationMap() {
      if (this.showDestinationMap == false) {
        this.showDestinationMap = true;
      }
    },
    onClickOutsideOrigignMap() {
      if (this.showOriginMap == false) {
        this.showOriginMap = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
// [dir=rtl] #wizard {
//     direction: ltr !important;
//     text-align: left !important;
// }
.dropup .dropdown-menu {
}

[dir="rtl"] .b-form-timepicker .dropdown-menu {
  right: 32px !important;
}
.image-container {
  width: 100% !important;
  height: 220px !important;
}
.preview-image {
  height: 165px !important;
}
.show-img {
  max-height: 100% !important;
}
</style>
<style lang="scss">
/* required styles */

[dir="rtl"] .leaflet-pane,
[dir="rtl"] .leaflet-tile,
[dir="rtl"] .leaflet-marker-icon,
[dir="rtl"] .leaflet-marker-shadow,
[dir="rtl"] .leaflet-tile-container,
[dir="rtl"] .leaflet-pane > svg,
[dir="rtl"] .leaflet-pane > canvas,
[dir="rtl"] .leaflet-zoom-box,
[dir="rtl"] .leaflet-image-layer,
[dir="rtl"] .leaflet-layer {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  direction: ltr !important;
}

[dir="rtl"] .leaflet-container {
  overflow: hidden;
  direction: ltr !important;
}
.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}
/* Prevents IE11 from highlighting tiles in blue */
.leaflet-tile::selection {
  background: transparent;
}
/* Safari renders non-retina tile on retina better with this, but Chrome is worse */
.leaflet-safari .leaflet-tile {
  image-rendering: -webkit-optimize-contrast;
}
/* hack that prevents hw layers "stretching" when loading new tiles */
.leaflet-safari .leaflet-tile-container {
  width: 1600px;
  height: 1600px;
  -webkit-transform-origin: 0 0;
}
.leaflet-marker-icon,
.leaflet-marker-shadow {
  display: block;
}
/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */
/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */
.leaflet-container .leaflet-overlay-pane svg,
.leaflet-container .leaflet-marker-pane img,
.leaflet-container .leaflet-shadow-pane img,
.leaflet-container .leaflet-tile-pane img,
.leaflet-container img.leaflet-image-layer,
.leaflet-container .leaflet-tile {
  max-width: none !important;
  max-height: none !important;
}

.leaflet-container.leaflet-touch-zoom {
  -ms-touch-action: pan-x pan-y;
  touch-action: pan-x pan-y;
}
.leaflet-container.leaflet-touch-drag {
  -ms-touch-action: pinch-zoom;
  /* Fallback for FF which doesn't support pinch-zoom */
  touch-action: none;
  touch-action: pinch-zoom;
}
.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
  -ms-touch-action: none;
  touch-action: none;
}
.leaflet-container {
  -webkit-tap-highlight-color: transparent;
}
.leaflet-container a {
  -webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);
}
.leaflet-tile {
  filter: inherit;
  visibility: hidden;
}
.leaflet-tile-loaded {
  visibility: inherit;
}
.leaflet-zoom-box {
  width: 0;
  height: 0;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 800;
}
/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */
.leaflet-overlay-pane svg {
  -moz-user-select: none;
}

.leaflet-pane {
  z-index: 400;
}

.leaflet-tile-pane {
  z-index: 200;
}
.leaflet-overlay-pane {
  z-index: 400;
}
.leaflet-shadow-pane {
  z-index: 500;
}
.leaflet-marker-pane {
  z-index: 600;
}
.leaflet-tooltip-pane {
  z-index: 650;
}
.leaflet-popup-pane {
  z-index: 700;
}

.leaflet-map-pane canvas {
  z-index: 100;
}
.leaflet-map-pane svg {
  z-index: 200;
}

.leaflet-vml-shape {
  width: 1px;
  height: 1px;
}
.lvml {
  /* behavior: url(#default#VML); */
  display: inline-block;
  position: absolute;
}

/* control positioning */

.leaflet-control {
  position: relative;
  z-index: 800;
  pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
  pointer-events: auto;
}
.leaflet-top,
.leaflet-bottom {
  position: absolute;
  z-index: 1000;
  pointer-events: none;
}
.leaflet-top {
  top: 0;
}
.leaflet-right {
  left: 0;
}
.leaflet-bottom {
  bottom: 0;
}
.leaflet-left {
  left: 0;
}
.leaflet-control {
  float: left;
  clear: both;
}
.leaflet-right .leaflet-control {
  float: right;
}
.leaflet-top .leaflet-control {
  margin-top: 10px;
}
.leaflet-bottom .leaflet-control {
  margin-bottom: 10px;
}
.leaflet-left .leaflet-control {
  margin-left: 10px;
}
.leaflet-right .leaflet-control {
  margin-right: 10px;
}

/* zoom and fade animations */

.leaflet-fade-anim .leaflet-tile {
  will-change: opacity;
}
.leaflet-fade-anim .leaflet-popup {
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
  opacity: 1;
}
.leaflet-zoom-animated {
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
}
.leaflet-zoom-anim .leaflet-zoom-animated {
  will-change: transform;
}
.leaflet-zoom-anim .leaflet-zoom-animated {
  -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1);
}
.leaflet-zoom-anim .leaflet-tile,
.leaflet-pan-anim .leaflet-tile {
  -webkit-transition: none;
  -moz-transition: none;
  transition: none;
}

.leaflet-zoom-anim .leaflet-zoom-hide {
  visibility: hidden;
}

/* cursors */

.leaflet-interactive {
  cursor: pointer;
}
.leaflet-grab {
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: grab;
}
.leaflet-crosshair,
.leaflet-crosshair .leaflet-interactive {
  cursor: crosshair;
}
.leaflet-popup-pane,
.leaflet-control {
  cursor: auto;
}
.leaflet-dragging .leaflet-grab,
.leaflet-dragging .leaflet-grab .leaflet-interactive,
.leaflet-dragging .leaflet-marker-draggable {
  cursor: move;
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: grabbing;
}

/* marker & overlays interactivity */
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-image-layer,
.leaflet-pane > svg path,
.leaflet-tile-container {
  pointer-events: none;
}

.leaflet-marker-icon.leaflet-interactive,
.leaflet-image-layer.leaflet-interactive,
.leaflet-pane > svg path.leaflet-interactive,
svg.leaflet-image-layer.leaflet-interactive path {
  pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
  pointer-events: auto;
}

/* visual tweaks */

.leaflet-container {
  background: #ddd;
  outline: 0;
}
.leaflet-container a {
  color: #0078a8;
}
.leaflet-container a.leaflet-active {
  outline: 2px solid orange;
}
.leaflet-zoom-box {
  border: 2px dotted #38f;
  background: rgba(255, 255, 255, 0.5);
}

/* general typography */
.leaflet-container {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
}

/* general toolbar styles */

.leaflet-bar {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
  border-radius: 4px;
}
.leaflet-bar a,
.leaflet-bar a:hover {
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: black;
}
.leaflet-bar a,
.leaflet-control-layers-toggle {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
}
.leaflet-bar a:hover {
  background-color: #f4f4f4;
}
.leaflet-bar a:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.leaflet-bar a:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: none;
}
.leaflet-bar a.leaflet-disabled {
  cursor: default;
  background-color: #f4f4f4;
  color: #bbb;
}

.leaflet-touch .leaflet-bar a {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.leaflet-touch .leaflet-bar a:first-child {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.leaflet-touch .leaflet-bar a:last-child {
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

/* zoom control */

.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  font: bold 18px "Lucida Console", Monaco, monospace;
  text-indent: 1px;
}

.leaflet-touch .leaflet-control-zoom-in,
.leaflet-touch .leaflet-control-zoom-out {
  font-size: 22px;
}

/* layers control */

.leaflet-control-layers {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  background: #fff;
  border-radius: 5px;
}
.leaflet-control-layers-toggle {
  /* background-image: url(images/layers.png); */
  width: 36px;
  height: 36px;
}
.leaflet-retina .leaflet-control-layers-toggle {
  /* background-image: url(images/layers-2x.png); */
  background-size: 26px 26px;
}
.leaflet-touch .leaflet-control-layers-toggle {
  width: 44px;
  height: 44px;
}
.leaflet-control-layers .leaflet-control-layers-list,
.leaflet-control-layers-expanded .leaflet-control-layers-toggle {
  display: none;
}
.leaflet-control-layers-expanded .leaflet-control-layers-list {
  display: block;
  position: relative;
}
.leaflet-control-layers-expanded {
  padding: 6px 10px 6px 6px;
  color: #333;
  background: #fff;
}
.leaflet-control-layers-scrollbar {
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 5px;
}
.leaflet-control-layers-selector {
  margin-top: 2px;
  position: relative;
  top: 1px;
}
.leaflet-control-layers label {
  display: block;
}
.leaflet-control-layers-separator {
  height: 0;
  border-top: 1px solid #ddd;
  margin: 5px -10px 5px -6px;
}

/* Default icon URLs */
/* .leaflet-default-icon-path {
	background-image: url(images/marker-icon.png);
	} */

/* attribution and scale controls */

.leaflet-container .leaflet-control-attribution {
  background: #fff;
  background: rgba(255, 255, 255, 0.7);
  margin: 0;
}
.leaflet-control-attribution,
.leaflet-control-scale-line {
  padding: 0 5px;
  color: #333;
}
.leaflet-control-attribution a {
  text-decoration: none;
}
.leaflet-control-attribution a:hover {
  text-decoration: underline;
}
.leaflet-container .leaflet-control-attribution,
.leaflet-container .leaflet-control-scale {
  font-size: 11px;
}
.leaflet-left .leaflet-control-scale {
  margin-left: 5px;
}
.leaflet-bottom .leaflet-control-scale {
  margin-bottom: 5px;
}
.leaflet-control-scale-line {
  border: 2px solid #777;
  border-top: none;
  line-height: 1.1;
  padding: 2px 5px 1px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  background: #fff;
  background: rgba(255, 255, 255, 0.5);
}
.leaflet-control-scale-line:not(:first-child) {
  border-top: 2px solid #777;
  border-bottom: none;
  margin-top: -2px;
}
.leaflet-control-scale-line:not(:first-child):not(:last-child) {
  border-bottom: 2px solid #777;
}

.leaflet-touch .leaflet-control-attribution,
.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  box-shadow: none;
}
.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 2px solid rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
}

/* popup */

.leaflet-popup {
  position: absolute;
  text-align: center;
  margin-bottom: 20px;
}
.leaflet-popup-content-wrapper {
  padding: 1px;
  text-align: left;
  border-radius: 12px;
}
.leaflet-popup-content {
  margin: 13px 19px;
  line-height: 1.4;
}
.leaflet-popup-content p {
  margin: 18px 0;
}
.leaflet-popup-tip-container {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
}
.leaflet-popup-tip {
  width: 17px;
  height: 17px;
  padding: 1px;

  margin: -10px auto 0;

  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: white;
  color: #333;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
}
.leaflet-container a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}
.leaflet-container a.leaflet-popup-close-button:hover {
  color: #999;
}
.leaflet-popup-scrolled {
  overflow: auto;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.leaflet-oldie .leaflet-popup-content-wrapper {
  zoom: 1;
}
.leaflet-oldie .leaflet-popup-tip {
  width: 24px;
  margin: 0 auto;

  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
}
.leaflet-oldie .leaflet-popup-tip-container {
  margin-top: -1px;
}

.leaflet-oldie .leaflet-control-zoom,
.leaflet-oldie .leaflet-control-layers,
.leaflet-oldie .leaflet-popup-content-wrapper,
.leaflet-oldie .leaflet-popup-tip {
  border: 1px solid #999;
}

/* div icon */

.leaflet-div-icon {
  background: #fff;
  border: 1px solid #666;
}

/* Tooltip */
/* Base styles for the element that has a tooltip */
.leaflet-tooltip {
  position: absolute;
  padding: 6px;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 3px;
  color: #222;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}
.leaflet-tooltip.leaflet-clickable {
  cursor: pointer;
  pointer-events: auto;
}
.leaflet-tooltip-top:before,
.leaflet-tooltip-bottom:before,
.leaflet-tooltip-left:before,
.leaflet-tooltip-right:before {
  position: absolute;
  pointer-events: none;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Directions */

.leaflet-tooltip-bottom {
  margin-top: 6px;
}
.leaflet-tooltip-top {
  margin-top: -6px;
}
.leaflet-tooltip-bottom:before,
.leaflet-tooltip-top:before {
  left: 50%;
  margin-left: -6px;
}
.leaflet-tooltip-top:before {
  bottom: 0;
  margin-bottom: -12px;
  border-top-color: #fff;
}
.leaflet-tooltip-bottom:before {
  top: 0;
  margin-top: -12px;
  margin-left: -6px;
  border-bottom-color: #fff;
}
.leaflet-tooltip-left {
  margin-left: -6px;
}
.leaflet-tooltip-right {
  margin-left: 6px;
}
.leaflet-tooltip-left:before,
.leaflet-tooltip-right:before {
  top: 50%;
  margin-top: -6px;
}
.leaflet-tooltip-left:before {
  right: 0;
  margin-right: -12px;
  border-left-color: #fff;
}
.leaflet-tooltip-right:before {
  left: 0;
  margin-left: -12px;
  border-right-color: #fff;
}
.custom-bg {
  background-color: #efefef; /* Replace with your desired custom color */
}
// .b-overlay{
//   z-index:10000!important
// }

.editor-font .editor-font{
  font-family: anjoman !important;
}
.editor-font .ql-editor{
  font-family: anjoman !important;
}
</style>
